import { MessageSquare, Code2, ListChecks, Network, Crosshair, Sparkles, CheckCircle2, Clock } from 'lucide-react';
import { useT } from '@/i18n/provider';
import { ProductFlowSection, type FlowStep, type FlowChip } from './ProductFlow';

const STEPS: FlowStep[] = [
  { icon: MessageSquare, title: 'Your Question', sublabel: 'Natural language', accent: 'info' },
  { icon: Code2, title: 'Generated LPQL', sublabel: 'Auto-written query', accent: 'primary' },
  { icon: ListChecks, title: 'Results', sublabel: '42 matching logs', accent: 'success' },
  { icon: Network, title: 'Correlation', sublabel: 'Across 3 services', accent: 'warning' },
  { icon: Crosshair, title: 'Root Cause', sublabel: 'Payments timeout', accent: 'danger' },
];

export function AiSearchFlow() {
  const t = useT();
  const chips: FlowChip[] = [
    { icon: MessageSquare, title: t('aiSearchPage.flow.naturalLanguage.title'), sublabel: t('aiSearchPage.flow.naturalLanguage.sub'), accent: 'info' },
    { icon: Sparkles, title: t('aiSearchPage.flow.aiPowered.title'), sublabel: t('aiSearchPage.flow.aiPowered.sub'), accent: 'primary' },
    { icon: CheckCircle2, title: t('aiSearchPage.flow.accurate.title'), sublabel: t('aiSearchPage.flow.accurate.sub'), accent: 'success' },
    { icon: Clock, title: t('aiSearchPage.flow.faster.title'), sublabel: t('aiSearchPage.flow.faster.sub'), accent: 'warning' },
  ];
  return (
    <ProductFlowSection
      title={t('aiSearchPage.flow.title')}
      subtitle={t('aiSearchPage.flow.subtitle')}
      steps={STEPS}
      chips={chips}
      gradient
    />
  );
}
